var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 58,
    viewBox: "0 0 78 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6475 51.8749V55.5763C18.6475 56.0668 18.8418 56.5386 19.1897 56.8848C19.5359 57.2326 20.0077 57.4269 20.4982 57.4269H57.5118C58.0022 57.4269 58.474 57.2326 58.8201 56.8848C59.168 56.5386 59.3623 56.0668 59.3623 55.5763V51.8749C59.3623 46.4766 57.2174 41.2983 53.3995 37.4804C49.5815 33.6624 44.4033 31.5176 39.0049 31.5176C33.6066 31.5176 28.4283 33.6624 24.6103 37.4804C20.7924 41.2983 18.6475 46.4766 18.6475 51.8749Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99037 57.4285H15.2633C15.0543 56.84 14.945 56.2145 14.945 55.5779V51.8765C14.945 47.6496 16.0573 43.5374 18.1189 39.9322C16.5736 39.2808 14.8766 38.9219 13.0943 38.9219C5.93971 38.9219 0.139648 44.7218 0.139648 51.8765V55.5779C0.139649 56.5995 0.968729 57.4285 1.99037 57.4285Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9133 38.9219C63.131 38.9219 61.434 39.2808 59.8887 39.9322C61.9503 43.5374 63.0626 47.6496 63.0626 51.8765V55.5779C63.0626 56.2145 62.9533 56.84 62.7443 57.4285H76.0172C77.0389 57.4285 77.868 56.5995 77.868 55.5779V51.8765C77.868 44.7218 72.0679 38.9219 64.9133 38.9219Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5607 32.5838C23.2095 29.0066 23.2675 23.1489 19.6903 19.5001C16.1131 15.8514 10.2553 15.7934 6.60661 19.3706C2.95788 22.9478 2.89988 28.8055 6.47707 32.4543C10.0543 36.103 15.912 36.161 19.5607 32.5838Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3925 32.6059C75.0416 29.0284 75.0996 23.1701 71.5221 19.5211C67.9446 15.872 62.0863 15.814 58.4373 19.3915C54.7882 22.969 54.7302 28.8273 58.3077 32.4763C61.8852 36.1254 67.7435 36.1834 71.3925 32.6059Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.056 27.6334C48.1175 26.4959 52.9198 19.8492 51.7823 12.7876C50.6447 5.72609 43.998 0.923761 36.9364 2.06133C29.8749 3.19891 25.0726 9.8456 26.2101 16.9071C27.3477 23.9687 33.9944 28.771 41.056 27.6334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord30);
export default __webpack_public_path__ + "static/media/accord_30.14e9a4b550c5a84eb24c5152d704f33e.svg";
export { ForwardRef as ReactComponent };